import React from 'react';
import CoursespageSection from '../components/Courses/CoursespageSection';
import UniqueBanner from "../components/UniqueBanner";
import SeoContentSection from "../components/SeoContentSection";
import BannerImg from "../assets/Institute/DSC_0575.JPG";

const Courses = () => {
  return (
    <>
        <UniqueBanner
  image={BannerImg}
  title="Teacher Training Courses"
  subtitle="Enhance your skills with our expert-led training programs"
 />
 <SeoContentSection title="Teacher Training Courses in Bangalore">
   <p>
     NIECCE offers career-focused teacher training courses in Bangalore for aspiring nursery, Montessori, pre-primary, and primary educators. Each course combines clear theory with practical activities so students can build confidence before entering a classroom.
   </p>
   <p>
     Choose a Montessori course, pre-primary training course, nursery teacher training program, or primary teacher training course based on your career goals. Our faculty supports learners through classroom demonstrations, value-added programs, certification, and placement guidance.
   </p>
 </SeoContentSection>
 <CoursespageSection />
    </>
  );
};

export default Courses;
